import { render } from "./ResetPage.vue?vue&type=template&id=20642bbc&scoped=true"
import script from "./ResetPage.vue?vue&type=script&lang=js"
export * from "./ResetPage.vue?vue&type=script&lang=js"

import "./ResetPage.vue?vue&type=style&index=0&id=20642bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20642bbc"]])

export default __exports__